import $ from "jquery";
import {transactionsSliderConfig} from './sliders-config';

export function initTransactionsCarousel() {
  if($('#people_transactions_slider')) {
    const config = transactionsSliderConfig();

    $('#people_transactions_slider').slick(config);
  } 
};
